import { JSEncrypt } from 'jsencrypt';
import { useContext, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';

import { cemInitiateOTP, customerOfferEligibility } from '../../api/api';

import DeviceOTP from '../common/DeviceOTP/DeviceOTP';
import { deleteCookies } from '../../Utils/deleteCookies';
import DeviceClaim from '../common/DeviceClaim/DeviceClaim';
import DeviceTerms from '../common/DeviceTerms/DeviceTerms';
import DeviceLogin from '../common/DeviceLogin/DeviceLogin';
import SubsidySuccess from '../common/SubsidySuccess/SubsidySuccess';
import SubsidyErrorModal from '../common/SubsidyErrorModal/SubsidyErrorModal';
import ErrorModal from '../ErrorModal/ErrorModal';

import './Subsidy.scss';

const win: any = window;

function Subsidy() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { subPageToDisplay, rtl, deviceFlow } = state;
    const { t } = useTranslation();

    const [headerCancel, setHeaderCancel] = useState(false);
    const [isCemInitiateOTPError, setIsCemInitiateOTPError] = useState(false);
    const [isLoginOTPError, setisLoginOTPError] = useState(false);
    const [isLoginStatusCode, setIsLoginStatusCode] = useState(false);
    const [isCemInitiateOTPGenericError, setIsCemInitiateOTPGenericError] = useState(false);
    const [notEligibleOffer, setNotEligibleOffer] = useState(false);
    const [timer, setTimer] = useState(0);
    const [errorCode, setErrorCode] = useState('');

    const [transId, setTransId] = useState('');
    const [errCode, setErrCode] = useState('');
    const childRef: any = useRef("");

    const activeFlow = deviceFlow || sessionStorage.getItem('device-flow');

    const handleSubmit = (number: string, userID: string) => {
        const lang = rtl ? 'ar' : 'en';
        const isDeviceOffline = win['device_offline'];
        const isOffline = isDeviceOffline === 'true';
        if (isOffline) {
            getCustomerOffersEligibility(number, userID, lang);
        } else {
            cemCallInitiateOTPApi(number, userID, lang);
        }

        dispatch({ type: "LOADER", payload: { loading: true } });
    }

    // new customer eligibility offers for customers below fn
    // we will remove later after approval

    const getCustomerOffersEligibility = (number: string, userID: string, lang: string) => {
        const msisdn = number.length > 0 ? number.replace(/^05/, "9665") : '';

        customerOfferEligibility(msisdn)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    setNotEligibleOffer(false);

                    let flow = activeFlow;
                    if (activeFlow === 'instalment') {
                        flow = 'installment';
                    }

                    const normalizedResponse = Object.fromEntries(
                        Object.entries(res.data).map(([k, v]) => [k.toLowerCase(), v])
                    );
                    const responseFlow = normalizedResponse[flow];

                    if (typeof responseFlow === 'string' && responseFlow.toLowerCase() === 'y') {
                        cemCallInitiateOTPApi(number, userID, lang);
                    } else {
                        setNotEligibleOffer(true);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setNotEligibleOffer(true);
                }
            }).catch(() => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                setNotEligibleOffer(true);
            })
    }

    const cemCallInitiateOTPApi = (msisdn: any, userID: any, lang: any) => {
        const cemPublicKey = win['cem_public_key'];
        const jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(cemPublicKey);

        const msisdnVal = msisdn.length > 0 ? msisdn.replace(/^0/, "966") : '';
        const mobileNumber = jsencrypt.encrypt(msisdnVal);
        const idNumber = jsencrypt.encrypt(userID);

        cemInitiateOTP(mobileNumber, idNumber, lang)
            .then((res: any) => {
                setErrorCode(res?.data?.status?.sourceCode ? res?.data?.status?.sourceCode : res?.status);
                if (res?.status === 200 && res?.data) {
                    if (res?.data?.status?.sourceCode === 'MAPI-000') {
                        setTimer(120);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        dispatch({ type: 'INITATE_OTP_DATA', payload: { OTPData: res?.data } });
                        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceOTP' } });
                        dispatch({ type: 'DEVICE_MOBILENUMBER', payload: { msisdn: msisdn.replace(/^966/, '0'), encryptedMSISDN: mobileNumber } });
                    } else {
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        const errCode = res?.status
                        setTransId(res?.config?.headers['X-Transaction-Id']);
                        setErrCode(errCode);
                        setIsCemInitiateOTPGenericError(true);
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });

                    if (res.status === 401 && res?.data?.status?.sourceCode === 'MAPI-401-5') {
                        const err = res?.status;
                        setTransId(res?.config?.headers['X-Transaction-Id']);
                        setErrCode(err);
                        setIsCemInitiateOTPError(true);
                    } else
                        if (res.status === 401 && res?.data?.status?.sourceCode === 'MAPI-401-09') {
                            setisLoginOTPError(true);
                            setIsLoginStatusCode(true);
                        }
                        else
                            if (res.status === 401 && res?.data?.status?.sourceCode === 'MAPI-401-10') {
                                setisLoginOTPError(true);
                                setIsLoginStatusCode(false);
                            }
                            else {
                                const errCode = res?.status
                                setTransId(res?.config?.headers['X-Transaction-Id']);
                                setErrCode(errCode);
                                setIsCemInitiateOTPGenericError(true);
                            }
                }
            }).catch(() => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                setIsCemInitiateOTPGenericError(true);
            })
    }

    const handleHeaderCancel = () => {
        setHeaderCancel(true);
    }

    const handleTryAgain = () => {
        document.body.style.overflow = 'auto';
        setisLoginOTPError(false);
    }

    const handleModalContinue = () => {
        setHeaderCancel(false);
    }

    const handleModalGotIt = () => {
        setIsCemInitiateOTPError(false);
        setIsCemInitiateOTPGenericError(false);
    }

    const handleModalDiscard = () => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        setHeaderCancel(false);
        sessionStorage.removeItem('device-flow');
        deleteCookies('device-scId');
        deleteCookies('device-xCoId');
        deleteCookies('device-count');
        deleteCookies('device-poid');
        deleteCookies('device-journeyName');
        document.body.style.overflow = 'auto';
        const wcmElement: any = document.getElementById("reactWCMControlBlockID");
        if (wcmElement !== null) {
            wcmElement.style.display = 'block';
        }
        window.location.reload();
        // dispatch({ type: 'PAGE_TO_DISPLAY', payload: { pageToDisplay: 'ProductDetails' } });
    }

    //remove it later
    const handleNotEligibleOffer = () => {
        setNotEligibleOffer(false);
        handleModalDiscard();
        dispatch({ type: 'DEVICE_FLOW', payload: { deviceFlow: '' } });
        // childRef?.current?.removeMobileNumber();
    }

    return (
        <div className='SubsidyFlow__Container container'>
            <div className='TransactionID' id="TransactionID" style={{ display: 'none' }}>{transId}</div>
            <div className='ErrorCode' id="ErrorCode" style={{ display: 'none' }}>{errCode}</div>
            {subPageToDisplay === 'deviceLogin' && (
                <DeviceLogin
                    ref={childRef}
                    handleSubmit={handleSubmit}
                    handleHeaderCancel={handleHeaderCancel}
                />
            )}
            {subPageToDisplay === 'deviceOTP' && (
                <DeviceOTP
                    timer={timer}
                    setTimer={setTimer}
                    handleHeaderCancel={handleHeaderCancel}
                />
            )}
            {subPageToDisplay === 'deviceClaimPlan' && (
                <DeviceClaim
                    handleHeaderCancel={handleHeaderCancel}
                />
            )}
            {subPageToDisplay === 'deviceTermsNCondition' && (
                <DeviceTerms
                    handleHeaderCancel={handleHeaderCancel}
                />
            )}
            {subPageToDisplay === 'deviceSubsidySuccess' && (
                <SubsidySuccess />
            )}

            {headerCancel && (
                <SubsidyErrorModal
                    id='duplicate-shopping-cartId'
                    title={activeFlow === 'subsidy' ? t('Cancel_subsidy') : t('discard_installment_title')}
                    description={activeFlow === 'subsidy' ? t('Info_lost_go_back') : t('go_back_installment_information_lost')}
                    firstButtonText={activeFlow === 'subsidy' ? t('Continue_Subsidy') : t('continue_with_installment')}
                    secButtonText={activeFlow === 'subsidy' ? t('Cancel_subsidy_btn') : t('discard_installment_button')}
                    modalFirstButtonClick={handleModalContinue}
                    modalSecondButtonClick={handleModalDiscard}
                />
            )}
            {(isCemInitiateOTPError || isCemInitiateOTPGenericError) && (
                <SubsidyErrorModal
                    id='duplicate-shopping-cartId'
                    description={''}
                    title={isCemInitiateOTPError ? t('contact_not_match') : t('Try_again', { source_code: t(errorCode) })}
                    firstButtonText={t('Got_it')}
                    secButtonText={''}
                    modalFirstButtonClick={handleModalGotIt}
                    modalSecondButtonClick={handleModalDiscard}
                />
            )}
            {isLoginOTPError && (
                <ErrorModal
                    id={'not-a-mobily-number'}
                    rtl={rtl}
                    title={isLoginStatusCode ? t('login_x2') : t('login_x1')}
                    description={''}
                    firstButtonText={t('Got_it')}
                    modalFirstButtonClick={handleTryAgain}
                />
            )}

            {/* below modal remove it later */}
            {notEligibleOffer && (
                <ErrorModal
                    id={'not-a-mobily-number'}
                    rtl={rtl}
                    title={activeFlow === 'subsidy' ? t('CEM_1325_title') : t('26215_title')}
                    description={activeFlow === 'subsidy' ? t('eligibility_body') : t('26215_body')}
                    firstButtonText={t('Got_it')}
                    modalFirstButtonClick={handleNotEligibleOffer}
                />
            )}
        </div>
    )
}

export default Subsidy;
